import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { AxiosError } from 'axios'
// @ts-ignore
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
// @ts-ignore
import { getShopList } from '../../../actions/shop'
// @ts-ignore
import { getCompanies } from '../../../actions/company'
// @ts-ignore
import { getOrganizations } from '../../../actions/organization'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { ReactSelectOption } from '../../../types'
import { Grid, Snackbar, Typography } from '@material-ui/core'
import { ICompany, ICompanyReducer } from 'models/contracts/company'
import { IAppTarget, IShop } from '../../../models/contracts/shop'
import {
  enableCompanyMigration,
  getCompanyShopsAndEmployeesMigrationStatus,
  getMigrationsRequests,
  getMigrationStatus,
  migrateCompanyBrandsCollection,
  migrateCompanyCategoriesCollection,
  migrateCompanyShopsAndEmployees,
  migrateCompanyVendorsCollection,
  migrateProductsCollection,
  autoOnboardingSync,
  migratePricingTempaltesCollection,
  getAutoOnboardingSyncStatus,
  generateCompanyProductsReport,
  getCompanySnapshotList,
  downloadCompanySnapshot,
  updateEventsForCompanyMigration,
  productMigrationDedupeValidate,
  productMigrationBulkCreate,
  productMigrationUpdateShopPlatformIds,
  getProductMigrationStatus,
  getDisabledEventsCompanies,
  enableProductEvents,
  disableProductEvents,
  syncOpenSearchTask,
  validateProductMigration,
  productMigrationPrevalidate,
  fixDuplicateProductNames,
} from '../../../api/companyMigration'
import {
  CollectionType,
  CompanyShopsAndEmployeesMigrationResponse,
  CompanySnapshotItem,
  EDomain,
  EAutoOnboardingStepStatus,
  MigrationCollections,
  MigrationStatus,
  ImportSyncStatusResponse,
  ProductMigrationStep,
  ProductMigrationStepStatus,
  ProductMigrationState,
  EProductExportDedupeKey,
  ProductMigrationValidationResponse,
} from '../../../types/migration'

// @ts-ignore
import { getShopListAPI } from '../../../api/shopV2'
import { CompanyCollections, ShopCollections, SyncConfirmationModal } from './SyncConfirmationModal'
import { CollectionDetailsModal } from './MigrateCompanyProducts/CollectionDetailsModal'
import { CompanyCollectionDetailsModal } from './MigrateCompanyProducts/CompanyCollectionDetailsModal'
import { CompanySelector, ShopSelector } from './MigrateCompanyProducts/CompanyShopSelector'
import { CompanyCollectionsGroup } from './MigrateCompanyProducts/CompanyCollectionsGroup'
import {
  CompanySnapshotGroup,
  hasValidSnapshot,
} from './MigrateCompanyProducts/CompanySnapshotGroup'
import { ShopCollectionsGroup } from './MigrateCompanyProducts/ShopCollectionsGroup'
import {
  defaultMigrationState,
  ProductMigrationGroup,
  productMigrationReps,
} from './MigrateCompanyProducts/ProductMigrationGroup'
import { MigrationActions } from './MigrateCompanyProducts/MigrationActions'
import { ImportStatusDetailsModal } from './MigrateCompanyProducts/ImportStatusDetailsModal'
import { ImportConfirmationModal } from './ImportConfirmationModal'
import { CustomAlert } from '../../../components/common/CustomAlert'

export type ShopOption = ReactSelectOption & {
  isMissingAddress: boolean
  isMissingState: boolean
  isMissingEmail: boolean
}

const shopOptionLabels: Record<
  keyof Pick<ShopOption, 'isMissingAddress' | 'isMissingState' | 'isMissingEmail'>,
  string
> = {
  isMissingAddress: 'Address',
  isMissingState: 'State',
  isMissingEmail: 'Email',
}

const collectionDomainMap: Partial<Record<MigrationCollections, EDomain>> = {
  [MigrationCollections.Brands]: EDomain.BRAND,
  [MigrationCollections.Vendors]: EDomain.VENDOR,
  [MigrationCollections.Categories]: EDomain.CATEGORY,
  [MigrationCollections.Products]: EDomain.PRODUCT,
  [MigrationCollections.PricingTemplates]: EDomain.PRICING_TEMPLATES,
}

interface IMigrateCompanyPropsPageProps {
  authReducer: any
  shopReducer: any
  organizationReducer: any
  companyReducer: ICompanyReducer
  messageReducer: any
  getShopList: () => Promise<{ values: IShop[] }>
  getCompanies: () => Promise<ICompany[]>
  getOrganizations: () => Promise<any[]>
}

export const unsyncedStatuses = [MigrationStatus.NOT_SYNCED, MigrationStatus.ERROR, undefined]

const migrationActions = {
  migrateCompanyData: async (companyId: string) => {
    try {
      await migrateCompanyShopsAndEmployees({ companyId })
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },

  migrateCategoryData: async (companyId: string, shopIds: string[]) => {
    try {
      await migrateCompanyCategoriesCollection({ companyId, shopIds })
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },

  migrateVendorData: async (companyId: string) => {
    try {
      await migrateCompanyVendorsCollection({ companyId, shopIds: [] })
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },

  migrateBrandData: async (companyId: string) => {
    try {
      await migrateCompanyBrandsCollection({ companyId, shopIds: [] })
      return true
    } catch (error) {
      console.log(error)
      console.error(error)
      return false
    }
  },

  migrateProductsData: async (companyId: string, shopIds: string[]) => {
    try {
      await migrateProductsCollection({ companyId, shopIds })
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },
  migratePricingTemplatesData: async (companyId: string, shopIds: string[]) => {
    try {
      await migratePricingTempaltesCollection({
        companyId,
        shopIds,
      })
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },
}

const MigrateCompanyProductsPage: React.FC<IMigrateCompanyPropsPageProps> = (props) => {
  const [detailsModalOpen, setDetailsModalOpen] = useState(false)
  const [importModalOpen, setImportModalOpen] = useState(false)
  const [importError, setImportError] = useState(false)
  const [companyDetailsModalOpen, setCompanyDetailsModalOpen] = useState(false)
  const [companies, setCompanies] = useState<ReactSelectOption[]>([])
  const [shops, setShops] = useState<ShopOption[]>([])
  const [selectedShops, setSelectedShops] = useState<ShopOption[] | undefined>(undefined)
  const [selectedCompany, setSelectedCompany] = useState<ReactSelectOption | undefined>(undefined)
  const [isGettingDetails, setIsGettingDetails] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [isImporting, setIsImporting] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [isDataImported, setIsDataImported] = useState(false)
  const [isGettingShops, setIsGettingShops] = useState(false)
  const [isRefreshingCompany, setIsRefreshingCompany] = useState(false)
  const [migrationCompanyStatus, setMigrationCompanyStatus] = useState<MigrationStatus>(
    MigrationStatus.NOT_SYNCED,
  )
  const [companyMigrationDetails, setCompanyMigrationDetails] = useState<
    CompanyShopsAndEmployeesMigrationResponse | undefined
  >(undefined)

  // Product migration state
  const [productMigrationState, setProductMigrationState] =
    useState<ProductMigrationState>(defaultMigrationState)

  const [isMissingShops, setIsMissingShops] = useState(false)
  const [migrationRequestsMap, setMigrationRequestsMap] = useState<
    Map<MigrationCollections, any[]>
  >(new Map())
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [showSnackbar, setShowSnackbar] = useState(false)
  const [showSyncModal, setShowSyncModal] = useState(false)
  const [selectedCollection, setSelectedCollection] = useState<MigrationCollections | undefined>(
    undefined,
  )
  const [shopCollections, setShopCollections] = useState<ShopCollections[]>([])
  const [companyCollections, setCompanyCollections] = useState<CompanyCollections>({
    collections: [],
  })

  const handleOpenSnackbar = useCallback((message: string) => {
    setErrorMessage(message)
    setShowSnackbar(true)
  }, [])

  const [isCompanyCollectionSelected, setIsCompanyCollectionSelected] = useState(false)
  const [isBrandCollectionSelected, setIsBrandCollectionSelected] = useState(false)
  const [isVendorCollectionSelected, setIsVendorCollectionSelected] = useState(false)
  const [isCategoryCollectionSelected, setIsCategoryCollectionSelected] = useState(false)
  const [isProductCollectionSelected, setIsProductCollectionSelected] = useState(false)
  const [isPricingTemplateCollectionSelected, setIsPricingTemplateCollectionSelected] =
    useState(false)
  const [importStatuses, setImportStatuses] = useState<ImportSyncStatusResponse | undefined>(
    undefined,
  )
  const [isImportStatusLoading, setIsImportStatusLoading] = useState(false)
  const [importDetailsCollection, setImportDetailsCollection] =
    useState<MigrationCollections | null>(null)
  const [isImportDetailsModalOpen, setImportDetailsModalOpen] = useState(false)
  const [dedupeKeys, setDedupeKeys] = useState<EProductExportDedupeKey[]>([
    EProductExportDedupeKey.NAME,
  ])

  // Company Products Snapshot state
  const [latestSnapshot, setLatestSnapshot] = useState<CompanySnapshotItem | undefined>(undefined)
  const [isGeneratingSnapshot, setIsGeneratingSnapshot] = useState(false)

  // Product Events state
  const [areProductEventsEnabled, setAreProductEventsEnabled] = useState<boolean | undefined>(
    undefined,
  )
  const [isTogglingEvents, setIsTogglingEvents] = useState(false)

  const getRetailShopsByCompanyId = async (companyId: string) => {
    try {
      setIsGettingShops(true)
      const shops = await getShopListAPI({ companyId })
      const retailShops = (shops || []).filter((shop) => shop.appTarget === IAppTarget.RETAIL)
      return retailShops
    } catch (error) {
      console.error(error)
      return []
    } finally {
      setIsGettingShops(false)
    }
  }

  const getCompanies = async (): Promise<ICompany[]> => {
    try {
      const companies = await props.getCompanies()
      return companies || []
    } catch (error) {
      handleOpenSnackbar('Failed to get companies. Please contact support')
      console.error(error)
      return []
    }
  }

  const mapShopsToOptions = (shops: IShop[]) => {
    return shops.map((shop) => {
      const isMissingAddress = !shop.address?.address
      const isMissingState = !shop.address?.state
      const isMissingEmail = !shop.emailAdress
      return {
        label: shop.name,
        value: shop.id,
        isMissingAddress,
        isMissingState,
        isMissingEmail,
      }
    })
  }

  const onChangeCompany = async (company: ReactSelectOption) => {
    if (!company || company.value === selectedCompany?.value) return
    resetMigrationDetails()
    const shops = await getRetailShopsByCompanyId(company.value)
    const shopsOptions = mapShopsToOptions(shops)
    setSelectedCompany(company)
    setShops(shopsOptions)
    setSelectedShops(undefined)
    //await updateMigrationState(company.value, [])
  }

  const onChangeShop = async (shop: ShopOption[]) => {
    if (!selectedCompany) return
    if (shop.length === 0) {
      setSelectedShops([])
      resetCollectionSelections()
      return
    }
    setSelectedShops(shop)
  }

  const fetchCompaniesAndShops = async (): Promise<void> => {
    const companiesResponse = await getCompanies()
    if (companiesResponse.length === 0) {
      setCompanies([])
      setShops([])
      setSelectedCompany(undefined)
      setSelectedShops(undefined)
      return
    }
    const companyOptions = companiesResponse.map((company) => {
      return { label: company.name, value: company.id }
    })
    setCompanies(companyOptions)
    return
    //return { companyId: firstCompany.value, shopIds: [firstShop.value] }
  }

  const enableMigration = async () => {
    if (!selectedCompany || !selectedShops) return
    await enableCompanyMigration({ companyId: selectedCompany?.value, enableGlSync: true })
  }

  const migrateCompanyData = async () => {
    if (!selectedCompany || !selectedShops) return
    setMigrationCompanyStatus(MigrationStatus.QUEUED)
    try {
      await migrateCompanyShopsAndEmployees({ companyId: selectedCompany?.value })
      handleOpenSnackbar('Company data migration started successfully')
    } catch (error) {
      console.error(error)
      setMigrationCompanyStatus(MigrationStatus.NOT_SYNCED)
    }
  }

  const migrateCategoryData = async ({ shopIds }: { shopIds: string[] }) => {
    if (!selectedCompany) return
    try {
      await migrateCompanyCategoriesCollection({
        companyId: selectedCompany?.value,
        shopIds,
      })
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to migrate categories. Please try again.')
    }
  }

  const migrateVendorData = async ({ shopIds }: { shopIds: string[] }) => {
    if (!selectedCompany) return
    try {
      // Vendors are company-level, so we send an empty array for shopIds
      await migrateCompanyVendorsCollection({
        companyId: selectedCompany?.value,
        shopIds: [],
      })
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to migrate vendors. Please try again.')
    }
  }

  const migrateBrandData = async () => {
    if (!selectedCompany) return
    try {
      await migrateCompanyBrandsCollection({
        companyId: selectedCompany?.value,
        shopIds: [],
      })
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to migrate brands. Please try again.')
    }
  }

  const migrateProductsData = async ({ shopIds }: { shopIds: string[] }) => {
    if (!selectedCompany) return
    try {
      await migrateProductsCollection({
        companyId: selectedCompany?.value,
        shopIds,
      })
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to migrate products. Please try again.')
    }
  }

  const handleFixDuplicateProducts = async () => {
    if (!selectedCompany) return
    await fixDuplicateProductNames({ companyId: selectedCompany.value })
  }

  const handleProductMigrationStep = async (step: ProductMigrationStep) => {
    if (!selectedCompany || !selectedShops || selectedShops.length === 0) {
      handleOpenSnackbar('Please select company and shops first')
      return
    }

    const glCompanyIdValue = companyMigrationDetails?.data?.platformCompanyId
      ? parseInt(companyMigrationDetails?.data?.platformCompanyId)
      : undefined

    if (!glCompanyIdValue) {
      handleOpenSnackbar('GL Company ID not available. Please check company migration status.')
      return
    }

    const shopIds = selectedShops.map((shop) => shop.value)

    // Update step status to IN_PROGRESS
    setProductMigrationState((prevState) => ({
      ...prevState,
      isRunning: true,
      steps: prevState.steps.map((stepInfo) =>
        stepInfo.step === step
          ? { ...stepInfo, status: ProductMigrationStepStatus.IN_PROGRESS, startedAt: Date.now() }
          : stepInfo,
      ),
    }))

    try {
      // Call the appropriate API function with correct parameters
      if (step === ProductMigrationStep.DEDUPE_VALIDATE) {
        await updateEventsForCompanyMigration(glCompanyIdValue, {
          action: 'disable',
        })
        await productMigrationDedupeValidate({
          glCompanyId: glCompanyIdValue,
          companyId: selectedCompany.value,
          shopIds,
          dedupeKeys,
        })
      } else if (step === ProductMigrationStep.PREVALIDATE) {
        const validationResponse = await productMigrationPrevalidate({
          glCompanyId: glCompanyIdValue,
          companyId: selectedCompany.value,
          shopIds,
          dedupeKeys,
        })

        if (validationResponse.duplicateProducts.length === 0) {
          setProductMigrationState((prevState) => ({
            ...prevState,
            isRunning: false,
            steps: prevState.steps.map((stepInfo) =>
              stepInfo.step === step
                ? {
                    ...stepInfo,
                    status: ProductMigrationStepStatus.DONE,
                    completedAt: Date.now(),
                    message: undefined,
                  }
                : stepInfo,
            ),
          }))

          handleOpenSnackbar(
            `Step "${productMigrationReps[step].label}" completed successfully! All products validated.`,
          )
        } else {
          setProductMigrationState((prevState) => ({
            ...prevState,
            isRunning: false,
            steps: prevState.steps.map((stepInfo) =>
              stepInfo.step === step
                ? {
                    ...stepInfo,
                    status: ProductMigrationStepStatus.FAILED,
                    completedAt: Date.now(),
                    message: JSON.stringify(validationResponse, null, 2),
                  }
                : stepInfo,
            ),
          }))
          handleOpenSnackbar(
            `Step "${productMigrationReps[step].label}" completed with ${validationResponse.duplicateProducts.length} validation errors.`,
          )
        }
        return
      } else if (step === ProductMigrationStep.BULK_CREATE) {
        await productMigrationBulkCreate({ glCompanyId: glCompanyIdValue })
      } else if (step === ProductMigrationStep.VALIDATE_MIGRATION) {
        const validationResponse: ProductMigrationValidationResponse =
          await validateProductMigration({ glCompanyId: glCompanyIdValue, dedupeKeys })

        if (validationResponse.validationResults.failed === 0) {
          setProductMigrationState((prevState) => ({
            ...prevState,
            isRunning: false,
            steps: prevState.steps.map((stepInfo) =>
              stepInfo.step === step
                ? {
                    ...stepInfo,
                    status: ProductMigrationStepStatus.DONE,
                    completedAt: Date.now(),
                    message: undefined,
                  }
                : stepInfo,
            ),
          }))

          handleOpenSnackbar(
            `Step "${productMigrationReps[step].label}" completed successfully! All products validated.`,
          )
        } else {
          setProductMigrationState((prevState) => ({
            ...prevState,
            isRunning: false,
            steps: prevState.steps.map((stepInfo) =>
              stepInfo.step === step
                ? {
                    ...stepInfo,
                    status: ProductMigrationStepStatus.FAILED,
                    completedAt: Date.now(),
                    message: JSON.stringify(validationResponse, null, 2),
                  }
                : stepInfo,
            ),
          }))

          handleOpenSnackbar(
            `Step "${productMigrationReps[step].label}" completed with ${validationResponse.validationResults.failed} validation errors.`,
          )
        }
        return
      } else if (step === ProductMigrationStep.UPDATE_PLATFORM_IDS) {
        await productMigrationUpdateShopPlatformIds({
          glCompanyId: glCompanyIdValue,
          companyId: selectedCompany.value,
        })
      } else if (step === ProductMigrationStep.SYNC_OPEN_SEARCH) {
        await syncOpenSearchTask({
          usCompanyId: selectedCompany.value,
        })

        // For SYNC_OPEN_SEARCH, mark as DONE immediately since it's async and not tracked
        setProductMigrationState((prevState) => ({
          ...prevState,
          isRunning: false,
          steps: prevState.steps.map((stepInfo) =>
            stepInfo.step === step
              ? {
                  ...stepInfo,
                  status: ProductMigrationStepStatus.DONE,
                  completedAt: Date.now(),
                  message:
                    'Sync task initiated successfully. The process will continue in the background.',
                }
              : stepInfo,
          ),
        }))

        handleOpenSnackbar(
          `Step "${productMigrationReps[step].label}" initiated successfully! The sync process is running in the background.`,
        )
        return // Return early for SYNC_OPEN_SEARCH
      }

      handleOpenSnackbar(
        `Step "${productMigrationReps[step].label}" started successfully! Use the refresh button to check status.`,
      )
    } catch (error: any) {
      console.error(`Product migration step ${step} error:`, error)

      // Update step status to FAILED
      setProductMigrationState((prevState) => ({
        ...prevState,
        isRunning: false,
        steps: prevState.steps.map((stepInfo) =>
          stepInfo.step === step
            ? {
                ...stepInfo,
                status: ProductMigrationStepStatus.FAILED,
                message: error?.message || 'An error occurred during migration',
              }
            : stepInfo,
        ),
      }))

      handleOpenSnackbar(
        `Step "${productMigrationReps[step].label}" failed to start. Please try again.`,
      )
    }
  }

  // Product Events Management Functions
  const checkProductEventsStatus = async () => {
    const glCompanyIdValue = companyMigrationDetails?.data?.platformCompanyId
      ? parseInt(companyMigrationDetails?.data?.platformCompanyId)
      : undefined

    if (!glCompanyIdValue) return

    try {
      const response = await getDisabledEventsCompanies()
      const isEnabled = !response.disabledCompanyIds.includes(glCompanyIdValue)
      setAreProductEventsEnabled(isEnabled)
    } catch (error) {
      console.error('Error checking product events status:', error)
      setAreProductEventsEnabled(undefined)
    }
  }

  const handleToggleProductEvents = async () => {
    const glCompanyIdValue = companyMigrationDetails?.data?.platformCompanyId
      ? parseInt(companyMigrationDetails?.data?.platformCompanyId)
      : undefined

    if (!glCompanyIdValue) {
      handleOpenSnackbar('GL Company ID not available. Please check company migration status.')
      return
    }

    setIsTogglingEvents(true)

    try {
      if (areProductEventsEnabled) {
        await disableProductEvents({ companyId: glCompanyIdValue })
        setAreProductEventsEnabled(false)
        handleOpenSnackbar('Product events disabled successfully!')
      } else {
        await enableProductEvents({ companyId: glCompanyIdValue })
        setAreProductEventsEnabled(true)
        handleOpenSnackbar('Product events enabled successfully!')
      }
    } catch (error) {
      console.error('Error toggling product events:', error)
      handleOpenSnackbar('Failed to toggle product events. Please try again.')
    } finally {
      setIsTogglingEvents(false)
    }
  }

  const handleStartPrevalidate = () => {
    handleProductMigrationStep(ProductMigrationStep.PREVALIDATE)
  }

  const handleStartDedupeValidate = () => {
    handleProductMigrationStep(ProductMigrationStep.DEDUPE_VALIDATE)
  }

  const handleStartBulkCreate = () => {
    handleProductMigrationStep(ProductMigrationStep.BULK_CREATE)
  }

  const handleStartValidateMigration = () => {
    handleProductMigrationStep(ProductMigrationStep.VALIDATE_MIGRATION)
  }

  const handleStartUpdatePlatformIds = () => {
    handleProductMigrationStep(ProductMigrationStep.UPDATE_PLATFORM_IDS)
  }

  const handleStartSyncOpenSearch = () => {
    handleProductMigrationStep(ProductMigrationStep.SYNC_OPEN_SEARCH)
  }

  const resetMigrationDetails = () => {
    setCompanyMigrationDetails(undefined)
    setMigrationRequestsMap(new Map())
    setIsDataImported(false)
    setImportError(false)

    // Reset product migration state
    setProductMigrationState(defaultMigrationState)
  }

  const getCompanyMigrationDetails = async (
    companyId: string,
    expectedStatus: MigrationStatus,
  ): Promise<CompanyShopsAndEmployeesMigrationResponse | undefined> => {
    try {
      setMigrationCompanyStatus(MigrationStatus.QUEUED)
      setIsRefreshingCompany(true)
      const response = await getCompanyShopsAndEmployeesMigrationStatus({ companyId })
      setMigrationCompanyStatus(expectedStatus)
      setCompanyMigrationDetails(response)
      return response
    } catch (error) {
      console.error(error)
      setMigrationCompanyStatus(MigrationStatus.NOT_SYNCED)
      handleOpenSnackbar('Failed to get company migration details. Please try again.')
      resetCollectionSelections()
    } finally {
      setIsRefreshingCompany(false)
    }
  }

  const resetCollectionSelections = () => {
    setIsBrandCollectionSelected(false)
    setIsVendorCollectionSelected(false)
    setIsCategoryCollectionSelected(false)
    setIsProductCollectionSelected(false)
    setIsPricingTemplateCollectionSelected(false)
  }

  // Company Products Snapshot functions
  const fetchLatestSnapshot = useCallback(async (companyId: string) => {
    try {
      const response = await getCompanySnapshotList({ companyId, limit: 1 })
      const snapshots = response.values || []
      if (snapshots.length > 0) {
        setLatestSnapshot(snapshots[0])
      } else {
        setLatestSnapshot(undefined)
      }
    } catch (error) {
      console.error('Error fetching latest snapshot:', error)
      setLatestSnapshot(undefined)
    }
  }, [])

  const handleGenerateSnapshot = useCallback(async () => {
    if (!selectedCompany) {
      handleOpenSnackbar('Please select a company')
      return
    }

    if (shops.length === 0) {
      handleOpenSnackbar('No shops available for this company')
      return
    }

    try {
      setIsGeneratingSnapshot(true)
      const today = new Date().toLocaleDateString('en-US')

      // Use the first available shop since the API requires a shopId but it's not actually important which one
      const firstShop = shops[0]
      await generateCompanyProductsReport({
        companyId: selectedCompany.value,
        shopId: firstShop.value,
        startDate: today,
        endDate: today,
      })

      // Refresh snapshot list after generation
      setTimeout(() => {
        fetchLatestSnapshot(selectedCompany.value)
      }, 2000)
    } catch (error) {
      console.error('Error generating snapshot:', error)
      handleOpenSnackbar('Error generating snapshot. Please try again.')
    } finally {
      setIsGeneratingSnapshot(false)
    }
  }, [selectedCompany, shops, fetchLatestSnapshot, handleOpenSnackbar])

  const handleDownloadSnapshot = useCallback(
    async (snapshot: CompanySnapshotItem) => {
      if (!selectedCompany) return

      try {
        const blob = await downloadCompanySnapshot({
          companyId: selectedCompany.value,
          requestId: snapshot.id,
        })

        // Create download link
        const fileExtension = snapshot.format || 'csv'
        const fileType = `application/${fileExtension}` || 'application/octet-stream'
        const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }))
        const link = document.createElement('a')
        link.href = url
        link.download = `company-products-snapshot-${snapshot.companyId}-${snapshot.requestDate}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error downloading snapshot:', error)
        handleOpenSnackbar('Error downloading snapshot. Please try again.')
      }
    },
    [selectedCompany, handleOpenSnackbar],
  )

  const fetchImportStatus = useCallback(
    async (
      companyId: number,
      { showToastOnError = false }: { showToastOnError?: boolean } = {},
    ) => {
      try {
        setIsImportStatusLoading(true)
        const response = await getAutoOnboardingSyncStatus(companyId)
        setImportStatuses(response)
      } catch (error) {
        console.error(error)
        const message = 'Failed to load import status. Please try again.'
        if (showToastOnError) {
          handleOpenSnackbar(message)
        }
        setImportStatuses(undefined)
      } finally {
        setIsImportStatusLoading(false)
      }
    },
    [handleOpenSnackbar],
  )

  const getImportStatusByCollection = useCallback(
    (collection: MigrationCollections) => {
      const domain = collectionDomainMap[collection]
      if (!domain) return undefined
      return importStatuses?.[domain]
    },
    [importStatuses],
  )

  const handleImportDetailsOpen = useCallback((collection: MigrationCollections) => {
    setImportDetailsCollection(collection)
    setImportDetailsModalOpen(true)
  }, [])

  const handleImportDetailsClose = useCallback(() => {
    setImportDetailsModalOpen(false)
    setImportDetailsCollection(null)
  }, [])

  const getMigrationRequestsMap = async (companyId: string, shopIds: string[]) => {
    try {
      const response = await getMigrationsRequests({ companyId })
      const migrationRequests = response.data.attributes.values || []
      const filteredRequests = migrationRequests.filter((request) => {
        if (
          request.type === CollectionType.BrandMigration ||
          request.type === CollectionType.VendorMigration
        ) {
          return true
        }
        const requestShopIds = request.shopId.split(',')
        return requestShopIds.some((id) => shopIds.includes(id))
      })

      const newMigrationRequestsMap = new Map<MigrationCollections, any[]>()

      filteredRequests.forEach((request) => {
        let collectionType: MigrationCollections
        switch (request.type) {
          case CollectionType.BrandMigration:
            collectionType = MigrationCollections.Brands
            break
          case CollectionType.VendorMigration:
            collectionType = MigrationCollections.Vendors
            break
          case CollectionType.CategoryMigration:
            collectionType = MigrationCollections.Categories
            break
          case CollectionType.PricingTemplateMigration:
            collectionType = MigrationCollections.PricingTemplates
            break
          case CollectionType.ProductMigration:
            collectionType = MigrationCollections.Products
            break
          default:
            return
        }

        const existingRequests = newMigrationRequestsMap.get(collectionType) || []
        newMigrationRequestsMap.set(collectionType, [...existingRequests, request])
      })
      setMigrationRequestsMap(newMigrationRequestsMap)
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to migrate data. Please try again.')
    }
  }

  const refreshVendorMigrationDetails = async () => {
    if (!selectedCompany) return
    const vendorRequests = migrationRequestsMap.get(MigrationCollections.Vendors)
    if (vendorRequests?.length) {
      try {
        const vendorStatus = await getMigrationStatus({
          companyId: selectedCompany.value,
          migrationId: vendorRequests[0].id,
        })
        const newMap = new Map(migrationRequestsMap)
        newMap.set(MigrationCollections.Vendors, [vendorStatus.data.attributes])
        setMigrationRequestsMap(newMap)
      } catch (error) {
        console.error(error)
        handleOpenSnackbar('Failed to refresh vendor migration details. Please try again.')
      }
    }
  }

  const refreshBrandMigrationDetails = async () => {
    if (!selectedCompany) return
    const brandRequests = migrationRequestsMap.get(MigrationCollections.Brands)
    if (brandRequests?.length) {
      try {
        const brandStatus = await getMigrationStatus({
          companyId: selectedCompany.value,
          migrationId: brandRequests[0].id,
        })
        const newMap = new Map(migrationRequestsMap)
        newMap.set(MigrationCollections.Brands, [brandStatus.data.attributes])
        setMigrationRequestsMap(newMap)
      } catch (error) {
        console.error(error)
        handleOpenSnackbar('Failed to refresh brand migration details. Please try again.')
      }
    }
  }

  const refreshProductMigrationDetails = async () => {
    if (!selectedCompany) return
    const productRequests = migrationRequestsMap.get(MigrationCollections.Products)
    if (productRequests?.length) {
      try {
        const productStatus = await getMigrationStatus({
          companyId: selectedCompany.value,
          migrationId: productRequests[0].id,
        })
        const newMap = new Map(migrationRequestsMap)
        newMap.set(MigrationCollections.Products, [productStatus.data.attributes])
        setMigrationRequestsMap(newMap)
      } catch (error) {
        console.error(error)
        handleOpenSnackbar('Failed to refresh product migration details. Please try again.')
      }
    }
  }

  const refreshCategoryMigrationDetails = async () => {
    if (!selectedCompany) return
    const categoryRequests = migrationRequestsMap.get(MigrationCollections.Categories)
    if (categoryRequests?.length) {
      setIsRefreshing(true)
      try {
        const categoryStatus = await getMigrationStatus({
          companyId: selectedCompany.value,
          migrationId: categoryRequests[0].id,
        })
        const newMap = new Map(migrationRequestsMap)
        newMap.set(MigrationCollections.Categories, [categoryStatus.data.attributes])
        setMigrationRequestsMap(newMap)
      } catch (error) {
        console.error(error)
        handleOpenSnackbar('Failed to refresh category migration details. Please try again.')
      }
    }
  }

  // Add function to refresh migration status manually
  const refreshProductMigrationStatus = async () => {
    if (!selectedCompany) return

    const glCompanyIdValue = companyMigrationDetails?.data?.platformCompanyId
      ? parseInt(companyMigrationDetails?.data?.platformCompanyId)
      : undefined

    if (!glCompanyIdValue) {
      handleOpenSnackbar('GL Company ID not available. Please check company migration status.')
      return
    }

    try {
      const statusResponse = await getProductMigrationStatus({
        companyId: glCompanyIdValue.toString(),
      })

      const stepStateMap = {
        [ProductMigrationStep.PREVALIDATE]: statusResponse.preValidate,
        [ProductMigrationStep.DEDUPE_VALIDATE]: statusResponse.dedupe,
        [ProductMigrationStep.BULK_CREATE]: statusResponse.bulkCreate,
        [ProductMigrationStep.UPDATE_PLATFORM_IDS]: statusResponse.updatePlatformProductIds,
        [ProductMigrationStep.VALIDATE_MIGRATION]: null, // Not tracked by API
      }

      setProductMigrationState((prevState) => ({
        ...prevState,
        isRunning: Object.values(stepStateMap).some(
          (step) => step && (step.status === 'IN_PROGRESS' || step.status === 'RUNNING'),
        ),
        steps: prevState.steps.map((stepInfo) => {
          // For SYNC_OPEN_SEARCH step, maintain current state since it's not tracked by API
          if (stepInfo.step === ProductMigrationStep.SYNC_OPEN_SEARCH) return stepInfo

          const apiStepData = stepStateMap[stepInfo.step]
          if (!apiStepData) return stepInfo

          let newStatus: ProductMigrationStepStatus
          switch (apiStepData.status) {
            case 'DONE':
              newStatus = ProductMigrationStepStatus.DONE
              break
            case 'IN_PROGRESS':
            case 'RUNNING':
              newStatus = ProductMigrationStepStatus.IN_PROGRESS
              break
            case 'FAILED':
              newStatus = ProductMigrationStepStatus.FAILED
              break
            case 'NOT_STARTED':
            default:
              newStatus = ProductMigrationStepStatus.NOT_STARTED
              break
          }

          return {
            ...stepInfo,
            status: newStatus,
            message: apiStepData.error,
          }
        }),
      }))

      handleOpenSnackbar('Migration status refreshed successfully!')
    } catch (error) {
      console.error('Error refreshing product migration status:', error)
      handleOpenSnackbar('Failed to refresh migration status. Please try again.')
    }
  }

  const refreshMigrationDetails = async () => {
    if (!selectedCompany) return
    setIsRefreshing(true)
    await Promise.all([
      getCompanyMigrationDetails(selectedCompany.value, MigrationStatus.COMPLETED),
      handleImportStatusRefresh(),
      refreshCategoryMigrationDetails(),
      refreshVendorMigrationDetails(),
      refreshBrandMigrationDetails(),
      refreshProductMigrationDetails(),
      refreshProductMigrationStatus(), // Add product migration status refresh
    ])
    setIsRefreshing(false)
  }

  const updateMigrationState = async () => {
    try {
      setIsRefreshing(true)
      const companyId = selectedCompany?.value
      if (!companyId) return
      const [companyDetails, migrationRequests] = await Promise.all([
        getCompanyShopsAndEmployeesMigrationStatus({ companyId }),
        getMigrationsRequests({ companyId }),
      ])

      setCompanyMigrationDetails(companyDetails)
      setMigrationCompanyStatus(MigrationStatus.COMPLETED)
      const shopIds = selectedShops?.map((shop) => shop.value) || []
      if (companyDetails) {
        const missingShops = shopIds.filter(
          (shopId) => !companyDetails.data.syncedShopIds.includes(shopId),
        )
        if (missingShops.length) {
          setIsMissingShops(true)
          handleOpenSnackbar(
            'Some shops are not synced. Please sync them before exporting collections.',
          )
          resetCollectionSelections()
        } else {
          setIsMissingShops(false)
        }
      }

      const newMigrationRequestsMap = new Map<MigrationCollections, any[]>()
      const filteredRequests = (migrationRequests.data.attributes.values || []).filter(
        (request: any) => {
          if (
            request.type === CollectionType.BrandMigration ||
            request.type === CollectionType.VendorMigration
          ) {
            return true
          }
          const requestShopIds = request.shopId.split(',')
          return requestShopIds.some((id: string) => shopIds.includes(id))
        },
      )

      filteredRequests.forEach((request: any) => {
        const collectionType = getCollectionTypeFromRequest(request)
        if (collectionType) {
          const existingRequests = newMigrationRequestsMap.get(collectionType) || []
          newMigrationRequestsMap.set(collectionType, [...existingRequests, request])
        }
      })

      setMigrationRequestsMap(newMigrationRequestsMap)
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to get migration details. Please try again.')
      resetCollectionSelections()
      setMigrationCompanyStatus(MigrationStatus.NOT_SYNCED)
    } finally {
      setIsRefreshing(false)
    }
  }

  const getCollectionTypeFromRequest = (request: any): MigrationCollections | null => {
    switch (request.type) {
      case CollectionType.BrandMigration:
        return MigrationCollections.Brands
      case CollectionType.VendorMigration:
        return MigrationCollections.Vendors
      case CollectionType.CategoryMigration:
        return MigrationCollections.Categories
      case CollectionType.ProductMigration:
        return MigrationCollections.Products
      case CollectionType.PricingTemplateMigration:
        return MigrationCollections.PricingTemplates
      default:
        return null
    }
  }

  const handleExportV2 = async ({
    syncAction = 'all',
  }: { syncAction?: 'missing' | 'all' } = {}) => {
    if (!selectedCompany) return

    try {
      setIsExporting(true)
      await enableMigration()

      if (syncAction === 'missing') {
        await handleMissingSync()
      } else {
        await handleFullSync()
      }

      handleOpenSnackbar('Data exported successfully')
      setIsDataImported(false)
    } catch (error) {
      console.error(error)
      handleOpenSnackbar('Failed to export data. Please try again.')
    } finally {
      setIsExporting(false)
    }
  }

  const handleMissingSync = async () => {
    if (!selectedCompany) return

    const collectionsToSync: MigrationCollections[] = []
    const shopIds = selectedShops?.map((shop) => shop.value) || []

    if (isCompanyCollectionSelected) {
      const needsCompanySync = companyCollections.collections.some((collection) =>
        unsyncedStatuses.includes(collection.status),
      )
      if (needsCompanySync) {
        await handleSyncCompanyData()
      }
    }

    if (isBrandCollectionSelected) {
      const brandRequests = migrationRequestsMap.get(MigrationCollections.Brands)
      const latestBrandRequest = brandRequests?.[0]
      const brandStatus = latestBrandRequest?.status
      if (unsyncedStatuses.includes(brandStatus)) {
        collectionsToSync.push(MigrationCollections.Brands)
      }
    }

    if (isVendorCollectionSelected) {
      const vendorRequests = migrationRequestsMap.get(MigrationCollections.Vendors)
      const latestVendorRequest = vendorRequests?.[0]
      const vendorStatus = latestVendorRequest?.status
      if (unsyncedStatuses.includes(vendorStatus)) {
        collectionsToSync.push(MigrationCollections.Vendors)
      }
    }

    if (isCategoryCollectionSelected) {
      const failedCategoryShopIds = shopCollections
        .filter((shopCollection) => {
          const categoryCollection = shopCollection.collections.find(
            (c) => c.name === MigrationCollections.Categories,
          )
          return unsyncedStatuses.includes(categoryCollection?.status)
        })
        .map((shopCollection) => shopCollection.shop.value)

      if (failedCategoryShopIds.length > 0) {
        collectionsToSync.push(MigrationCollections.Categories)
      }
    }

    if (isProductCollectionSelected) {
      const failedProductShopIds = shopCollections
        .filter((shopCollection) => {
          const productCollection = shopCollection.collections.find(
            (c) => c.name === MigrationCollections.Products,
          )
          return unsyncedStatuses.includes(productCollection?.status)
        })
        .map((shopCollection) => shopCollection.shop.value)

      if (failedProductShopIds.length > 0) {
        collectionsToSync.push(MigrationCollections.Products)
      }
    }

    if (isPricingTemplateCollectionSelected) {
      const failedPricingTemplateShopIds = shopCollections
        .filter((shopCollection) => {
          const pricingTemplateCollection = shopCollection.collections.find(
            (c) => c.name === MigrationCollections.PricingTemplates,
          )
          return unsyncedStatuses.includes(pricingTemplateCollection?.status)
        })
        .map((shopCollection) => shopCollection.shop.value)

      if (failedPricingTemplateShopIds.length > 0) {
        collectionsToSync.push(MigrationCollections.PricingTemplates)
      }
    }

    if (collectionsToSync.length > 0) {
      await handleMigration(selectedCompany.value, shopIds, collectionsToSync)
    }
  }

  const handleFullSync = async () => {
    if (!selectedCompany) return

    const collectionsToSync: MigrationCollections[] = []
    const shopIds = selectedShops?.map((shop) => shop.value) || []

    if (isCompanyCollectionSelected) {
      collectionsToSync.push(MigrationCollections.Company)
    }
    if (isBrandCollectionSelected) {
      collectionsToSync.push(MigrationCollections.Brands)
    }
    if (isVendorCollectionSelected) {
      collectionsToSync.push(MigrationCollections.Vendors)
    }
    if (isCategoryCollectionSelected) {
      collectionsToSync.push(MigrationCollections.Categories)
    }
    if (isProductCollectionSelected) {
      collectionsToSync.push(MigrationCollections.Products)
    }

    if (isPricingTemplateCollectionSelected) {
      collectionsToSync.push(MigrationCollections.PricingTemplates)
    }

    await handleMigration(selectedCompany.value, shopIds, collectionsToSync)
  }

  const startExport = async () => {
    if (!selectedCompany) return

    const hasShopLevelCollections =
      isCategoryCollectionSelected ||
      isProductCollectionSelected ||
      isPricingTemplateCollectionSelected

    if (hasShopLevelCollections && (!selectedShops || selectedShops.length === 0)) {
      return
    }

    const companyLevelCollections = []

    if (isCompanyCollectionSelected) {
      companyLevelCollections.push(
        {
          name: MigrationCollections.Company,
          status: migrationCompanyStatus,
          created: undefined,
        },
        {
          name: MigrationCollections.Shops,
          status: migrationCompanyStatus,
          created: undefined,
        },
        {
          name: MigrationCollections.Employees,
          status: migrationCompanyStatus,
          created: undefined,
        },
      )
    }

    if (isBrandCollectionSelected) {
      const brandRequests = migrationRequestsMap.get(MigrationCollections.Brands)
      const latestBrandRequest = brandRequests?.[0]
      companyLevelCollections.push({
        name: MigrationCollections.Brands,
        status: latestBrandRequest?.status || MigrationStatus.NOT_SYNCED,
        created: latestBrandRequest?.created,
      })
    }

    if (isVendorCollectionSelected) {
      const vendorRequests = migrationRequestsMap.get(MigrationCollections.Vendors)
      const latestVendorRequest = vendorRequests?.[0]
      companyLevelCollections.push({
        name: MigrationCollections.Vendors,
        status: latestVendorRequest?.status || MigrationStatus.NOT_SYNCED,
        created: latestVendorRequest?.created,
      })
    }

    const companyCollections = {
      collections: companyLevelCollections,
    }

    const shopCollections = mapShopCollections()

    setShopCollections(shopCollections)
    setCompanyCollections(companyCollections)
    setShowSyncModal(true)
  }

  const handleSyncMissing = async () => {
    setShowSyncModal(false)
    await handleExportV2({ syncAction: 'missing' })
    if (selectedCompany?.value) {
      await getMigrationRequestsMap(
        selectedCompany?.value,
        selectedShops?.map((shop) => shop.value) || [],
      )
    }
  }

  const handleSyncAll = async () => {
    setShowSyncModal(false)
    await handleExportV2({ syncAction: 'all' })
    if (selectedCompany?.value) {
      await getMigrationRequestsMap(
        selectedCompany?.value,
        selectedShops?.map((shop) => shop.value) || [],
      )
    }
  }

  const handleSyncCompanyData = async () => {
    await enableMigration()
    await migrateCompanyData()
  }

  const closeModals = () => {
    setShowSyncModal(false)
    setCompanyDetailsModalOpen(false)
    setImportModalOpen(false)
  }

  const handleCloseSnackbar = () => {
    setShowSnackbar(false)
    setErrorMessage(null)
  }

  useEffect(() => {
    const fetchMigrationDetails = async () => {
      try {
        setIsGettingDetails(true)
        await fetchCompaniesAndShops()
      } catch (error) {
        console.error(error)
        handleOpenSnackbar('Failed to get migration details. Please try again.')
        resetCollectionSelections()
      } finally {
        setIsGettingDetails(false)
      }
    }
    fetchMigrationDetails()
  }, [])

  const glCompanyId = companyMigrationDetails?.data?.platformCompanyId
    ? parseInt(companyMigrationDetails?.data?.platformCompanyId)
    : undefined

  useEffect(() => {
    if (!glCompanyId) {
      setImportStatuses(undefined)
      setAreProductEventsEnabled(undefined)
      return
    }
    fetchImportStatus(glCompanyId)
    checkProductEventsStatus()
  }, [glCompanyId, fetchImportStatus])

  useEffect(() => {
    updateMigrationState()
  }, [selectedCompany, selectedShops])

  // Fetch snapshots when company changes
  useEffect(() => {
    if (selectedCompany?.value) {
      fetchLatestSnapshot(selectedCompany.value)
    } else {
      setLatestSnapshot(undefined)
    }
  }, [selectedCompany, fetchLatestSnapshot])

  const handleImportStatusRefresh = useCallback(() => {
    if (glCompanyId) {
      fetchImportStatus(glCompanyId, { showToastOnError: true })
    }
  }, [fetchImportStatus, glCompanyId])

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (isDataImported) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const handleDetailsModalOpen = (collectionName: MigrationCollections) => {
    setSelectedCollection(collectionName)
    setDetailsModalOpen(true)
  }

  const handleDetailsModalClose = () => {
    setDetailsModalOpen(false)
    setTimeout(() => {
      setSelectedCollection(undefined)
    }, 200)
  }

  const handleRetry = async (shop: ReactSelectOption, collectionName: MigrationCollections) => {
    if (collectionName === MigrationCollections.Brands) {
      migrateBrandData()
    }
    if (collectionName === MigrationCollections.Vendors) {
      migrateVendorData({ shopIds: [shop.value] })
    }
    if (collectionName === MigrationCollections.Categories) {
      migrateCategoryData({ shopIds: [shop.value] })
    }
    if (collectionName === MigrationCollections.Products) {
      migrateProductsData({ shopIds: [shop.value] })
    }
    if (selectedCompany?.value && selectedShops) {
      await updateMigrationState()
    }
    if (selectedCompany?.value && selectedShops) {
      await getMigrationRequestsMap(
        selectedCompany?.value,
        selectedShops.map((s) => s.value),
      )
    }
    closeModals()
  }

  const open = Boolean(anchorEl)

  const noSelectedShops = !selectedShops || selectedShops.length === 0
  const noSelectedCompany = !selectedCompany

  const noCompanyCheckboxEnabled = !isCompanyCollectionSelected
  const noShopCheckboxEnabled =
    !isBrandCollectionSelected &&
    !isVendorCollectionSelected &&
    !isCategoryCollectionSelected &&
    !isProductCollectionSelected &&
    !isPricingTemplateCollectionSelected
  const noCheckboxesEnabled = noCompanyCheckboxEnabled && noShopCheckboxEnabled

  const hasShopLevelCollectionsSelected =
    isCategoryCollectionSelected ||
    isProductCollectionSelected ||
    isPricingTemplateCollectionSelected

  const isLoading = isExporting || isRefreshing || isGettingDetails

  // Check if there's a valid snapshot available for download
  const hasValidSnapshotAvailable = hasValidSnapshot(latestSnapshot)
  // Also disable UI while generating snapshots
  const snapshotBlockingUI = isGeneratingSnapshot || !hasValidSnapshotAvailable

  const isNotExportableCollection =
    isLoading ||
    !glCompanyId ||
    noSelectedShops ||
    isRefreshingCompany ||
    isMissingShops ||
    noSelectedCompany ||
    snapshotBlockingUI

  const isNotExportableCompanyLevelCollection =
    isLoading || !glCompanyId || isRefreshingCompany || noSelectedCompany || snapshotBlockingUI

  const isExportDisabled =
    noCheckboxesEnabled ||
    !selectedCompany ||
    !glCompanyId ||
    isGettingDetails ||
    isRefreshingCompany ||
    isExporting ||
    (hasShopLevelCollectionsSelected && (noSelectedShops || isMissingShops)) ||
    snapshotBlockingUI

  const mapShopCollections = () => {
    if (!selectedShops) return []
    return selectedShops.map((shop) => {
      const collections = []
      // Brands and Vendors are company-level

      if (isCategoryCollectionSelected) {
        const categoryRequests = migrationRequestsMap.get(MigrationCollections.Categories)
        const shopCategoryRequests = categoryRequests?.filter((request) => {
          const requestShopIds = request.shopId.split(',')
          return requestShopIds.includes(shop.value)
        })
        collections.push({
          name: MigrationCollections.Categories,
          status: shopCategoryRequests?.[0]?.status || MigrationStatus.NOT_SYNCED,
          created: shopCategoryRequests?.[0]?.created,
        })
      }

      if (isProductCollectionSelected) {
        const productRequests = migrationRequestsMap.get(MigrationCollections.Products)
        const shopProductRequests = productRequests?.filter((request) => {
          const requestShopIds = request.shopId.split(',')
          return requestShopIds.includes(shop.value)
        })
        collections.push({
          name: MigrationCollections.Products,
          status: shopProductRequests?.[0]?.status || MigrationStatus.NOT_SYNCED,
          created: shopProductRequests?.[0]?.created,
        })
      }

      if (isPricingTemplateCollectionSelected) {
        const pricingTemplateRequests = migrationRequestsMap.get(
          MigrationCollections.PricingTemplates,
        )
        const shopPricingTemplateRequests = pricingTemplateRequests?.filter((request) => {
          const requestShopIds = request.shopId.split(',')
          return requestShopIds.includes(shop.value)
        })
        collections.push({
          name: MigrationCollections.PricingTemplates,
          status: shopPricingTemplateRequests?.[0]?.status || MigrationStatus.NOT_SYNCED,
          created: shopPricingTemplateRequests?.[0]?.created,
        })
      }

      return {
        shop,
        collections,
      }
    })
  }

  const handleMigration = async (
    companyId: string,
    shopIds: string[],
    collections: MigrationCollections[],
  ) => {
    const migrationPromises: Promise<boolean>[] = []

    if (collections.includes(MigrationCollections.Company)) {
      migrationPromises.push(migrationActions.migrateCompanyData(companyId))
    }

    if (collections.includes(MigrationCollections.Brands)) {
      migrationPromises.push(migrationActions.migrateBrandData(companyId))
    }

    if (collections.includes(MigrationCollections.Vendors)) {
      migrationPromises.push(migrationActions.migrateVendorData(companyId))
    }

    if (collections.includes(MigrationCollections.Categories)) {
      migrationPromises.push(migrationActions.migrateCategoryData(companyId, shopIds))
    }

    if (collections.includes(MigrationCollections.Products)) {
      migrationPromises.push(migrationActions.migrateProductsData(companyId, shopIds))
    }

    if (collections.includes(MigrationCollections.PricingTemplates)) {
      migrationPromises.push(migrationActions.migratePricingTemplatesData(companyId, shopIds))
    }

    const results = await Promise.all(migrationPromises)
    return results.every((result) => result)
  }

  const selectedShopCollections: EDomain[] = []

  if (isBrandCollectionSelected) {
    selectedShopCollections.push(EDomain.BRAND)
  }
  if (isVendorCollectionSelected) {
    selectedShopCollections.push(EDomain.VENDOR)
  }
  if (isCategoryCollectionSelected) {
    selectedShopCollections.push(EDomain.CATEGORY)
  }
  if (isPricingTemplateCollectionSelected) {
    selectedShopCollections.push(EDomain.PRICING_TEMPLATES)
  }
  const startImport = async (force?: boolean): Promise<void> => {
    if (!glCompanyId) {
      setIsImporting(false)
      return
    }
    try {
      setIsImporting(true)
      if (selectedShopCollections.length === 0) {
        setIsImporting(false)
        handleOpenSnackbar('Please select at least one collection to import.')
        return
      }
      await autoOnboardingSync(glCompanyId, { domains: selectedShopCollections, force })
      setIsDataImported(true)
      setImportError(false)
      setImportModalOpen(false)
    } catch (error) {
      const axiosError = error as AxiosError<{ message: string }>
      const errorMessage =
        axiosError?.response?.data?.message || 'Failed to import data. Please try again.'
      setImportError(true)
      handleOpenSnackbar(errorMessage)
    } finally {
      setIsImporting(false)
    }
  }
  const invalidShops = selectedShops?.filter(
    (shop) => shop.isMissingAddress || shop.isMissingState || shop.isMissingEmail,
  )

  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item xs={12} md={8} xl={10}>
          <div style={{ backgroundColor: '#f4f4f4', padding: '50px 75px' }}>
            <CompanyCollectionDetailsModal
              companyMigrationDetails={companyMigrationDetails}
              selectedCompany={selectedCompany}
              selectedShops={selectedShops}
              open={companyDetailsModalOpen}
              onClose={() => setCompanyDetailsModalOpen(false)}
              onSyncCompanyData={() => {
                closeModals()
                handleSyncCompanyData()
              }}
            />
            <CollectionDetailsModal
              selectedShops={selectedShops}
              open={detailsModalOpen}
              onClose={handleDetailsModalClose}
              collectionName={selectedCollection}
              migrationRequestsMap={migrationRequestsMap}
              onRetry={handleRetry}
            />
            <ImportStatusDetailsModal
              open={isImportDetailsModalOpen}
              onClose={handleImportDetailsClose}
              collectionName={importDetailsCollection}
              importStatus={
                importDetailsCollection
                  ? getImportStatusByCollection(importDetailsCollection)
                  : undefined
              }
            />
            <Snackbar
              className="notificationMessage"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={showSnackbar}
              onClose={handleCloseSnackbar}
              autoHideDuration={6000}
              message={<span id="message-id">{errorMessage}</span>}
            />
            <SyncConfirmationModal
              open={showSyncModal}
              onClose={() => setShowSyncModal(false)}
              onSyncMissingCollections={handleSyncMissing}
              onSyncCompanyData={() => {
                closeModals()
                handleSyncCompanyData()
              }}
              onSyncAll={handleSyncAll}
              shopCollections={shopCollections}
              companyCollections={companyCollections}
              selectedCompany={selectedCompany}
              companyMigrationDetails={companyMigrationDetails}
              selectedShops={selectedShops}
            />
            <Grid direction="column" spacing={24} container>
              <Grid item xs={12}>
                <CompanySelector
                  companies={companies}
                  selectedCompany={selectedCompany}
                  onCompanyChange={onChangeCompany}
                />
              </Grid>
              <Grid item xs={12}>
                <CompanySnapshotGroup
                  isLoading={isLoading}
                  isCompanySelected={Boolean(selectedCompany)}
                  hasAvailableShops={shops.length > 0}
                  latestSnapshot={latestSnapshot}
                  onGenerateSnapshot={handleGenerateSnapshot}
                  onDownloadSnapshot={handleDownloadSnapshot}
                  isGenerating={isGeneratingSnapshot}
                />
              </Grid>
              <Grid item xs={12}>
                <CompanyCollectionsGroup
                  migrationCompanyStatus={migrationCompanyStatus}
                  isCompanyCollectionSelected={isCompanyCollectionSelected}
                  isBrandCollectionSelected={isBrandCollectionSelected}
                  isCompanySelected={Boolean(selectedCompany)}
                  isVendorCollectionSelected={isVendorCollectionSelected}
                  isNotExportableCollection={isNotExportableCollection}
                  isNotExportableCompanyLevelCollection={isNotExportableCompanyLevelCollection}
                  isLoading={isLoading}
                  onCompanyDetailsModalOpen={() => setCompanyDetailsModalOpen(true)}
                  onCollectionDetailsModalOpen={handleDetailsModalOpen}
                  onCompanyCollectionToggle={() => setIsCompanyCollectionSelected((prev) => !prev)}
                  onBrandCollectionToggle={() => setIsBrandCollectionSelected((prev) => !prev)}
                  onVendorCollectionToggle={() => setIsVendorCollectionSelected((prev) => !prev)}
                  getImportStatusByCollection={getImportStatusByCollection}
                  onImportDetailsOpen={handleImportDetailsOpen}
                  isImportStatusLoading={isImportStatusLoading}
                />
              </Grid>
              <Grid item xs={12}>
                <ShopSelector
                  shops={shops}
                  selectedCompany={selectedCompany}
                  selectedShops={selectedShops}
                  isGettingShops={isGettingShops}
                  onShopChange={onChangeShop}
                />
              </Grid>
              <Grid item xs={12}>
                <ShopCollectionsGroup
                  migrationCompanyStatus={migrationCompanyStatus}
                  isCategoryCollectionSelected={isCategoryCollectionSelected}
                  isPricingTemplateCollectionSelected={isPricingTemplateCollectionSelected}
                  isNotExportableCollection={isNotExportableCollection}
                  onCollectionDetailsModalOpen={handleDetailsModalOpen}
                  isImportStatusLoading={isImportStatusLoading}
                  onCategoryCollectionToggle={() =>
                    setIsCategoryCollectionSelected((prev) => !prev)
                  }
                  onPricingTemplateCollectionToggle={() =>
                    setIsPricingTemplateCollectionSelected((prev) => !prev)
                  }
                  getImportStatusByCollection={getImportStatusByCollection}
                  onImportDetailsOpen={handleImportDetailsOpen}
                />
              </Grid>
              <Grid item xs={12}>
                <ProductMigrationGroup
                  isLoading={isImportStatusLoading}
                  isCompanySelected={!!selectedCompany}
                  hasSelectedShops={selectedShops ? selectedShops.length > 0 : false}
                  hasValidSnapshot={hasValidSnapshotAvailable}
                  areDependenciesMigrated={
                    getImportStatusByCollection(MigrationCollections.Brands)?.status ===
                      EAutoOnboardingStepStatus.SUCCEEDED &&
                    getImportStatusByCollection(MigrationCollections.Vendors)?.status ===
                      EAutoOnboardingStepStatus.SUCCEEDED &&
                    getImportStatusByCollection(MigrationCollections.Categories)?.status ===
                      EAutoOnboardingStepStatus.SUCCEEDED
                  }
                  onStartPrevalidate={handleStartPrevalidate}
                  onStartDedupeValidate={handleStartDedupeValidate}
                  onStartBulkCreate={handleStartBulkCreate}
                  onStartValidateMigration={handleStartValidateMigration}
                  onStartUpdatePlatformIds={handleStartUpdatePlatformIds}
                  onStartSyncOpenSearch={handleStartSyncOpenSearch}
                  onRefreshStatus={refreshProductMigrationStatus}
                  onToggleEvents={handleToggleProductEvents}
                  areEventsEnabled={areProductEventsEnabled}
                  isTogglingEvents={isTogglingEvents}
                  migrationState={productMigrationState}
                  dedupeKeys={dedupeKeys}
                  setDedupeKeys={setDedupeKeys}
                  handleFixDuplicateProducts={handleFixDuplicateProducts}
                />
              </Grid>
              <Grid item xs={12}>
                <MigrationActions
                  isExporting={isExporting}
                  isRefreshing={isRefreshing}
                  isImporting={isImporting}
                  isLoading={isLoading}
                  noShopCheckboxEnabled={noShopCheckboxEnabled}
                  selectedCompany={selectedCompany}
                  isGettingDetails={isGettingDetails}
                  glCompanyId={glCompanyId}
                  isExportDisabled={isExportDisabled}
                  onExport={startExport}
                  onRefresh={refreshMigrationDetails}
                  openImportModal={() => setImportModalOpen(true)}
                  onPopoverOpen={handlePopoverOpen}
                  onPopoverClose={handlePopoverClose}
                  anchorEl={anchorEl}
                />
              </Grid>
            </Grid>
            <ImportConfirmationModal
              open={importModalOpen}
              onClose={() => setImportModalOpen(false)}
              onImport={startImport}
              selectedShopCollections={selectedShopCollections}
              isImporting={isImporting}
              importError={importError}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={4} xl={2}>
          <div style={{ backgroundColor: 'pink' }}>
            {invalidShops && invalidShops?.length > 0 && (
              <CustomAlert severity="warning" variant="filled" title="Warning">
                <Typography>Some shops are missing required fields:</Typography>
                {invalidShops.map((invalidShop) => {
                  const missingFields = Object.entries(shopOptionLabels)
                    .filter(([key]) => invalidShop[key as keyof typeof shopOptionLabels])
                    .map(([_, label]) => label)

                  return (
                    <Typography key={invalidShop.value}>
                      <strong>{invalidShop.label}:</strong> {missingFields.join(', ')}
                    </Typography>
                  )
                })}
              </CustomAlert>
            )}
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

const mapStateToProps = (state: any) => {
  return {
    authReducer: state.authReducer,
    dispatch: state.dispatch,
    shopReducer: state.shopReducer,
    organizationReducer: state.organizationReducer,
    companyReducer: state.companyReducer,
    messageReducer: state.messageReducer,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<unknown, undefined, AnyAction>) => {
  return {
    getShopList: () => dispatch(getShopList()),
    getCompanies: () => dispatch(getCompanies()),
    getOrganizations: () => dispatch(getOrganizations()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContainerWithTitle(MigrateCompanyProductsPage, 'Migrate Company Products'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProductsPage.tsx